import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#other-measurements" }),
  /*#__PURE__*/_createTextVNode(" Other measurements ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " You can choose week, month, year or multiple dates by extending the standard date picker component. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "block mb-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Week", -1)
const _hoisted_8 = { class: "block mb-5" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Month", -1)
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "block mb-5" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Year", -1)
const _hoisted_13 = { class: "block mb-5" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Dates", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.value1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
            type: "week",
            format: "[Week] ww",
            placeholder: "Pick a week"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.value2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event)),
            type: "month",
            placeholder: "Pick a month"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.value3,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.value3 = $event)),
            type: "year",
            placeholder: "Pick a year"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_el_date_picker, {
            type: "dates",
            modelValue: _ctx.value4,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.value4 = $event)),
            placeholder: "Pick one or more dates"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}